import { FC, ReactNode } from "react";
import Base from "../Base";

const FullWidthLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return <Base fullWidth>{children}</Base>;
};

export default FullWidthLayout;
